var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "product-bottomline" }, [
    _vm.loaded
      ? _c(
          "div",
          { staticClass: "product-bottomline__rating" },
          [
            _vm.rating > 0 || _vm.displayNoReviews
              ? _c("star-rating", {
                  staticClass: "product-bottomline__stars",
                  attrs: { rating: _vm.rating },
                })
              : _vm._e(),
            _vm.count > 0
              ? _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "scroll-to",
                        rawName: "v-scroll-to",
                        value: { el: "#pdp_yotpo_reviews" },
                        expression: "{ el: '#pdp_yotpo_reviews' }",
                      },
                    ],
                    staticClass: "product-bottomline__count",
                    attrs: { href: "#" },
                  },
                  [_vm._v(_vm._s(_vm.reviewMessage))]
                )
              : _vm.loaded && _vm.displayNoReviews
              ? _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "scroll-to",
                        rawName: "v-scroll-to",
                        value: { el: "#pdp_yotpo_reviews" },
                        expression: "{ el: '#pdp_yotpo_reviews' }",
                      },
                    ],
                    staticClass: "product-bottomline__no-ratings",
                    attrs: { href: "#" },
                  },
                  [_vm._v("No reviews yet!")]
                )
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }